import React, { Component } from 'react';
import Layout from '../layout';
import NewsSectionOne from '../components/Esper/News/NewsSectionOne';
import NewsSectionTwo from '../components/Esper/News/NewsSectionTwo';
import { BottomBanner } from '../components/Esper/BottomBanner';
import BlogPosts from '../components/Esper/HomePage/BlogPosts';
import messages from '../i18n/en';

export default class Hardware extends Component<any, any> {
  render() {
    return (
      <Layout
        messages={messages}
        title={`Esper In The News | Esper Media Coverage`}
        keywords={`Esper Customer, Esper media coverage`}
        location={this.props.location}
        description={`Recent media coverage of Esper, the first platform for single-purpose Android device use cases like kiosk mode, mPoS, telehealth and more.`}
      >
        <NewsSectionOne />
        <NewsSectionTwo />
        <BottomBanner
          description={`Scale and deploy your Android devices
          on the field like never before!
          `}
          buttonText={`Start your free trial`}
          link="https://esper.io/signup"
        />
        <BlogPosts />
      </Layout>
    );
  }
}
